export const state = {
  isIphone: false,
  sidebarExpanded: window.innerWidth >= 1024,
}

export const getters = {
  isIphone: (state) => state.isIphone,
  sidebarExpanded: (state) => state.sidebarExpanded,
}

export const mutations = {
  SET_IS_IPHONE(state, isIphone) {
    state.isIphone = isIphone
  },

  TOGGLE_SIDEBAR(state) {
    state.sidebarExpanded = !state.sidebarExpanded
  },

  CHECK_SIDEBAR(state) {
    state.sidebarExpanded = window.innerWidth >= 1024
  },
}

export const actions = {
  init({ commit }) {
    const userAgent = navigator.userAgent
    if (userAgent.match(/iPhone/i)) {
      commit('SET_IS_IPHONE', true)
    }
  },

  toggleSidebar({ commit, state, rootState }) {
    commit('TOGGLE_SIDEBAR')
  },

  checkSidebar({ commit, state, rootState }) {
    commit('CHECK_SIDEBAR')
  },
}
